export const reportTypeOptions = [
  { value: 'client', label: 'Client Report' },
  { value: 'trade', label: 'Trade Report' },
  { value: 'financial', label: 'Financial Report' },
  { value: 'performance', label: 'Performance Report' },
];

export const dateRangeOptions = [
  { value: 'today', label: 'Today' },
  { value: 'week', label: 'This Week' },
  { value: 'month', label: 'This Month' },
  { value: 'quarter', label: 'This Quarter' },
  { value: 'year', label: 'This Year' },
  { value: 'custom', label: 'Custom Range' },
];

export const exportFormatOptions = [
  { value: 'pdf', label: 'PDF' },
  { value: 'excel', label: 'Excel' },
  { value: 'csv', label: 'CSV' },
];
